import { connectedStore } from '../../store';
import getExtensions from '../selectors/extensions';
import controlTypes from '../constants/control-types';

const findControlsFor = (element, controlType = controlTypes.ELEMENT) => {
  const store = connectedStore.get();
  const state = store.getState();
  const extensions = getExtensions(state);
  const controls = [];

  extensions.forEach((extension) => {
    const {
      ui: { control },
    } = extension;

    const controlMatches = control.filter((item) => {
      if (!item.for) {
        return controlTypes.ELEMENT === controlType;
      }

      return item.for.includes(controlType);
    });

    controls.push(...controlMatches);
  });

  return controls.filter((item) => item.matches(element));
};

export default findControlsFor;
